import React from "react";
import Navbar from "../../../components/main/navbar";
import Footer from "../../../components/main/footer";
import {
  Grid2,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  Container,
  Box,
} from "@mui/material";
import Time from "../../../images/time.svg";
import Upload from "../../../images/upload_resume.svg";
import Icon from "../../../images/icon.png";
import World from "../../../images/world.jpg";
import SaveTime from "../../../images/time.jpg";
import Resume from "../../../images/resume.jpg";
import Logo from "../../../images/icon.png";

const landingPage = () => {
  const offers = [
    {
      title: "15 lettres de motivation",
      price: 1.99,
      id: "price_1Qa5ZkCOl27OIxPKteBo9Elx",
      description: "Pack Découverte",
      color: "#342DBF",
      gradient: "linear-gradient(135deg, #342DBF, #5C4FBF)",
      presentation:
        "Idéal pour des candidatures rapides, le Pack Découverte inclut 15 lettres de motivation personnalisées pour seulement 1,99 €. Parfait pour ceux qui recherchent une solution simple et efficace.",
    },
    {
      title: "30 lettres de motivation",
      price: 3.99,
      id: "price_1Qa5cBCOl27OIxPKXDBuRGq2",
      description: "Pack Standard",
      color: "#A41243",
      gradient: "linear-gradient(135deg, #A41243, #C03F5A)",
      presentation:
        "Le Pack Standard propose 30 lettres de motivation sur mesure pour seulement 3,99 €. Conçu pour ceux qui postulent à plusieurs offres, c'est l'équilibre parfait entre valeur et flexibilité.",
    },
    {
      title: "50 lettres de motivation",
      price: 6.99,
      id: "price_1Qa5drCOl27OIxPKWgDsrYxu",
      description: "Pack Pro",
      color: "#9D1CB9",
      gradient: "linear-gradient(135deg, #9D1CB9, #B04FC3)",
      presentation:
        "Pour les chercheurs d'emploi assidus, le Pack Pro fournit 50 lettres de motivation personnalisées pour 6,99 € . Une solution complète pour garder des candidatures percutantes.",
    },
  ];

  return (
    <div>
      <Navbar />
      <Grid2
        container
        justifyContent="space-evenly"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
        bgcolor="#f8f9fc"
        flexDirection="column"
      >
        <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
          <Typography
            fontFamily="General Sans Regular"
            variant="body2"
            fontWeight="700"
            fontSize="30px"
          >
            SmartCandidate
          </Typography>
        </Grid2>

        <Grid2
          container
          justifyContent="space-evenly"
          flexDirection="row"
          wrap="wrap"
          gap={2}
          sx={{ width: "100%" }}
        >
          <Grid2
            xs={12}
            sm={9}
            sx={{
              width: {
                xs: "100%",
                sm: "80%",
                lg: "60%",
              },
            }}
          >
            {" "}
            <iframe
              width="100%"
              height="400px"
              src="https://www.youtube.com/embed/o7Sln6u4dbA"
              title="SmartCandidate"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                maxWidth: "1000px",
                borderRadius: "8px",
              }}
            ></iframe>
          </Grid2>
          <Grid2 container xs={12} sm={3} width="270px" justifyContent="center">
            <img src={`${Logo}`} height="200px" width="250px" alt="Succès !" />
            <Typography
              fontFamily="General Sans Regular"
              color="#146aff"
              fontWeight="700"
              textAlign="center"
              paddingTop="20px"
            >
              Démarquez-vous avec des lettres de motivation conçues pour mettre
              en valeur vos compétences et votre expérience, répondant
              parfaitement aux attentes des recruteurs.
            </Typography>
            <Button
              type="submit"
              fullWidth
              href="/signup"
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                fontWeight: "700",
                color: "white",
                backgroundColor: "#146aff",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  color: "white",
                  backgroundColor: "#004aad",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Inscription
            </Button>
            <Button
              fullWidth
              href="https://chromewebstore.google.com/detail/smartcandidate/jgccmimjdjmhacdmjilocpikbacfbhlc"
              target="_blank"
              variant="contained"
              sx={{
                mt: 1,
                mb: 2,
                fontWeight: "700",
                color: "white",
                backgroundColor: "#146aff",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  color: "white",
                  backgroundColor: "#004aad",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Installer
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 padding="50px" bgcolor="#f8f9fc">
        <Container>
          <Typography
            fontFamily="General Sans Regular"
            textAlign="center"
            variant="h4"
            gutterBottom
            fontWeight="700"
          >
            Choisissez votre formule
          </Typography>
          <Typography
            fontFamily="General Sans Regular"
            textAlign="center"
            variant="body2"
            gutterBottom
            fontWeight="700"
            marginBottom="10px"
          >
            Pas d'abonnement, payez à l'usage !
          </Typography>

          <Grid2 container spacing={3} justifyContent="space-evenly">
            {offers
              .filter((offer) => offer.price !== "FREE")
              .map((offer) => (
                <Grid2 item key={offer.id} xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      height: "430px",
                      background: offer.gradient,
                      borderRadius: 4,
                      padding: "30px",
                      textAlign: "center",
                      alignContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      color: "white",
                      transition: "transform 0.2s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <Typography
                      fontFamily="General Sans Regular"
                      variant="h5"
                      sx={{ marginBottom: "10px" }}
                    >
                      {offer.title}
                    </Typography>
                    <Typography
                      fontFamily="General Sans Regular"
                      variant="h4"
                      sx={{
                        fontWeight: "bold",
                        color: "white",
                        marginBottom: "20px",
                      }}
                    >
                      {offer.price} €
                    </Typography>

                    <Typography
                      fontFamily="General Sans Regular"
                      variant="h5"
                      sx={{
                        fontWeight: "bold",
                        color: "white",
                        marginBottom: "20px",
                        textAlign: "center",
                      }}
                    >
                      {offer.description}
                    </Typography>
                    <Grid2 container justifyContent="center" display="flex">
                      <Typography
                        fontFamily="General Sans Regular"
                        variant="body2"
                        sx={{
                          maxWidth: "200px",
                          color: "white",
                          marginBottom: "20px",
                        }}
                      >
                        {offer.presentation}
                      </Typography>
                    </Grid2>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        mt: 1,
                        mb: 2,
                        padding: "10px 25px 10px 25px",
                        fontWeight: "700",
                        color: offer.color,
                        backgroundColor: "white",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                        "&:hover": {
                          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                      href="/signup"
                    >
                      Choisir
                    </Button>
                  </Box>
                </Grid2>
              ))}
          </Grid2>
        </Container>
      </Grid2>
      <Grid2
        container
        bgcolor="#f8f9fc"
        flexDirection="column"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
      >
        <Grid2 marginBottom="20px">
          <Typography
            fontFamily="General Sans Regular"
            variant="h3"
            fontWeight="700"
            fontSize="30px"
          >
            Services
          </Typography>
        </Grid2>
        <Grid2 container flexDirection="row" gap={3} padding="30px">
          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "translateY(-10px)",
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            <CardMedia component="img" height="180" image={`${Resume}`} />
            <CardContent>
              <Typography
                fontFamily="General Sans Regular"
                gutterBottom
                variant="h5"
                component="div"
              >
                Personnalisée
              </Typography>
              <Typography
                fontFamily="General Sans Regular"
                variant="body2"
                color="inherit"
              >
                En analysant votre parcours et l'offre d'emploi, SmartCandidate
                rédige des lettres de motivation personnalisées pour chaque
                offre d'emploi.
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "translateY(-10px)",
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            <CardMedia component="img" height="180" image={`${SaveTime}`} />
            <CardContent>
              <Typography
                fontFamily="General Sans Regular"
                gutterBottom
                variant="h5"
                component="div"
              >
                Rapide
              </Typography>
              <Typography
                fontFamily="General Sans Regular"
                variant="body2"
                color="inherit"
              >
                Grâce à notre extension, SmartCandidate génère des documents de
                candidature de qualité, sans changer de page, en quelques
                secondes.
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "translateY(-10px)",
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            <CardMedia component="img" height="180" image={`${World}`} />
            <CardContent>
              <Typography
                fontFamily="General Sans Regular"
                gutterBottom
                variant="h5"
                component="div"
              >
                3 langues
              </Typography>
              <Typography
                fontFamily="General Sans Regular"
                variant="body2"
                color="inherit"
              >
                SmartCandidate est disponible en plusieurs langues, vous
                permettant de créer des documents professionnels adaptés à la
                région et à la langue de l'offre d'emploi.
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>
      <Grid2 container bgcolor="#f8f9fc" flexDirection="column" flexWrap="wrap">
        <Grid2 marginBottom="20px" marginTop="20px">
          <Typography
            fontFamily="General Sans Regular"
            variant="h3"
            fontWeight="700"
            fontSize="30px"
            textAlign="center"
          >
            Pourquoi SmartCandidate ?
          </Typography>
        </Grid2>
        <Grid2
          container
          bgcolor="#f8f9fc"
          flexDirection="row"
          alignItems="center"
          flexWrap="wrap"
          padding="20px"
          justifyContent="space-evenly"
        >
          <Grid2 xs={6} marginBottom="20px">
            <Typography
              fontFamily="General Sans Regular"
              sx={{ marginTop: "20px" }}
              variant="h3"
              fontSize="30px"
            >
              Gagnez du temps
            </Typography>
            <Typography
              fontFamily="General Sans Regular"
              variant="body1"
              maxWidth="500px"
            >
              Postuler à des offres d'emploi peut prendre du temps, mais
              SmartCandidate simplifie le processus grâce à une génération de
              documents rapide et facile. En quelques étapes seulement, vous
              disposerez de documents de candidature personnalisés.
            </Typography>
          </Grid2>
          <Grid2 xs={6} maxWidth="300px">
            <img src={`${Time}`} height="200px" width="auto" alt="Succès !" />
          </Grid2>
        </Grid2>
        <Grid2
          container
          bgcolor="#f8f9fc"
          flexDirection="row"
          alignItems="center"
          flexWrap="wrap"
          padding="20px"
          justifyContent="space-evenly"
        >
          <Grid2 xs={6} maxWidth="300px" marginBottom="20px">
            <img src={`${Upload}`} height="200px" width="auto" alt="Succès !" />
          </Grid2>
          <Grid2 xs={6}>
            <Typography
              fontFamily="General Sans Regular"
              sx={{ marginTop: "20px" }}
              variant="h3"
              fontSize="30px"
            >
              Une lettre de motivation personnalisée
            </Typography>
            <Typography
              fontFamily="General Sans Regular"
              variant="body1"
              maxWidth="500px"
            >
              SmartCandidate vous libère du stress lié à la création de
              candidatures sur mesure. En alignant votre expérience et vos
              compétences avec les exigences spécifiques de chaque poste,
              l'outil rédige des lettres de motivation percutantes et
              pertinentes.
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container bgcolor="#f8f9fc" flexDirection="column" flexWrap="wrap">
        <Grid2 marginBottom="20px" marginTop="20px">
          <Typography
            fontFamily="General Sans Regular"
            variant="h3"
            fontWeight="700"
            fontSize="30px"
            textAlign="center"
          >
            Contactez-nous
          </Typography>
        </Grid2>
        <Grid2
          container
          bgcolor="#f8f9fc"
          flexDirection="column"
          alignItems="center"
          flexWrap="wrap"
          padding="20px"
          justifyContent="center"
        >
          <Grid2 xs={6} maxWidth="300px">
            <img src={`${Icon}`} height="200px" width="auto" alt="Succès !" />
          </Grid2>
          <Grid2 xs={6} marginBottom="20px">
            <Typography
              fontFamily="General Sans Regular"
              sx={{ marginTop: "20px" }}
              variant="h3"
              fontSize="30px"
              textAlign="center"
            >
              SmartCandidate
            </Typography>
            <Typography
              fontFamily="General Sans Regular"
              variant="body1"
              maxWidth="500px"
              textAlign="center"
            >
              Libérez votre potentiel de carrière avec SmartCandidate !
              Rejoignez-nous dès aujourd'hui pour créer des lettres de
              motivation personnalisées et professionnelles qui vous
              distingueront. Avec des candidatures sur mesure, vous êtes plus
              proche que jamais de décrocher l'emploi de vos rêves.
            </Typography>
            <Button
              type="submit"
              fullWidth
              href="/contact-us"
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                fontWeight: "700",
                color: "white",
                backgroundColor: "#146aff",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  color: "white",
                  backgroundColor: "#004aad",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Contact
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>

      <Footer />
    </div>
  );
};

export default landingPage;
